import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { SeverityBadge, StatusBadge } from "@/components/Primitives";
import { Link } from "react-router-dom";
import { Search, Server } from "lucide-react";

export default function Assets() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  useEffect(() => { api.get("/assets", { params: { limit: 1000 } }).then(r => setItems(asArray(r.data))).catch(() => setItems([])); }, []);
  const filtered = items.filter(a => (!q || (a.hostname || "").toLowerCase().includes(q.toLowerCase()) || (a.serial_number || "").toLowerCase().includes(q.toLowerCase()))).filter(a => !status || a.status === status);
  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Asset Lifecycle</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Assets ({filtered.length})</h1>
        </div>
        <div className="flex gap-2">
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
            <input data-testid="asset-search" value={q} onChange={e=>setQ(e.target.value)} placeholder="Search hostname or serial" className="bg-zinc-950 border border-zinc-800 rounded-md pl-9 pr-3 py-1.5 text-sm w-72 focus:outline-none focus:border-blue-500/60" />
          </div>
          <select value={status} onChange={e=>setStatus(e.target.value)} data-testid="asset-status-filter" className="bg-zinc-950 border border-zinc-800 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:border-blue-500/60">
            <option value="">All status</option>
            <option value="active">Active</option>
            <option value="maintenance">Maintenance</option>
            <option value="retired">Retired</option>
          </select>
        </div>
      </div>

      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 border-b border-zinc-900 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
            <tr>
              <th className="text-left px-4 py-3">Hostname</th>
              <th className="text-left px-4 py-3">Category</th>
              <th className="text-left px-4 py-3">Manufacturer</th>
              <th className="text-left px-4 py-3">OS</th>
              <th className="text-left px-4 py-3">IP</th>
              <th className="text-left px-4 py-3">Health</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Last Seen</th>
            </tr>
          </thead>
          <tbody>
            {filtered.slice(0, 200).map(a => (
              <tr key={a.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2 font-mono text-zinc-200"><Link to={`/assets/${a.id}`} className="hover:text-blue-400" data-testid={`asset-link-${a.id}`}>{a.hostname}</Link></td>
                <td className="px-4 py-2 text-zinc-400 capitalize">{a.category}</td>
                <td className="px-4 py-2 text-zinc-400">{a.manufacturer} <span className="text-zinc-600">· {a.model}</span></td>
                <td className="px-4 py-2 text-zinc-400">{a.os}</td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{a.ip_address}</td>
                <td className="px-4 py-2"><span className={`font-mono text-xs ${a.health_score >= 80 ? "text-emerald-400" : a.health_score >= 60 ? "text-amber-400" : "text-red-400"}`}>{a.health_score}</span></td>
                <td className="px-4 py-2"><StatusBadge status={a.status} /></td>
                <td className="px-4 py-2 text-zinc-500 font-mono text-xs">{a.last_seen_at?.slice(11, 16)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length > 200 && <div className="px-4 py-2 text-xs text-zinc-500">Showing 200 of {filtered.length} · refine filters to see more</div>}
      </div>
    </div>
  );
}
